import { Routes } from '@angular/router';
import { unsavedChangesGuard } from './common/guards/unsaved-changes.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('../layout/component/app.layout').then((m) => m.AppLayout),
    children: [
      { path: '', redirectTo: 'utilisateurs', pathMatch: 'full' },
      {
        path: 'utilisateurs',
        loadComponent: () =>
          import('./features/users/users-list/users-list.component').then((m) => m.UsersListComponent),
      },
      {
        path: 'utilisateurs/:id',
        loadComponent: () =>
          import('./features/users/user-detail/user-detail.component').then((m) => m.UserDetailComponent),
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: 'groups',
        loadComponent: () =>
          import('./features/groups/groups-list/groups-list.component').then(
            (m) => m.GroupsListComponent,
          ),
      },
      {
        path: 'groups/:id',
        loadComponent: () =>
          import('./features/groups/group-detail/group-detail.component').then(
            (m) => m.GroupDetailComponent,
          ),
        canDeactivate: [unsavedChangesGuard],
      } 
    ],
  },
  { path: '**', redirectTo: 'utilisateurs' },
];
